import { extend, override } from 'flarum/common/extend';
import AvatarEditor from 'flarum/forum/components/AvatarEditor';

import Component from 'flarum/common/Component';
import avatar from 'flarum/common/helpers/avatar';
import icon from 'flarum/common/helpers/icon';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import classList from 'flarum/common/utils/classList';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

override(AvatarEditor.prototype, 'view', function() {
  const user = this.attrs.user;

  return (
    <div className={classList(['AvatarEditor', 'Dropdown', this.attrs.className])}>
      {avatar(user)}
      <a
        className={user.avatarUrl() ? 'Dropdown-toggle' : 'Dropdown-toggle AvatarEditor--noAvatar'}
        title={app.translator.trans('core.forum.user.avatar_upload_tooltip')}
        data-toggle="dropdown"
      >
        {this.loading ? (
          <LoadingIndicator display="unset" size="large" />
        ) : user.avatarUrl() ? (
          icon('fas fa-pencil-alt')
        ) : (
          icon('fas fa-plus-circle')
        )}
      </a>
      <ul className="Dropdown-menu Menu">{listItems(this.controlItems().toArray())}</ul>
    </div>
  );
});

extend(AvatarEditor.prototype, 'controlItems', function(items) {
  items.replace(
    'upload',
    <Button icon="fas fa-upload" onclick={() =>  window.open('https://my.cloud.gg/settings','_blank')}>
      Upload (via CloudGG)
    </Button>
  );

  items.replace(
    'remove',
    <Button icon="fas fa-times" onclick={() =>  window.open('https://my.cloud.gg/settings','_blank')}>
      Remove (via CloudGG)
    </Button>
  );
});

override(AvatarEditor.prototype, 'enableDragover', function() {
  return;
});

override(AvatarEditor.prototype, 'disableDragover', function() {
  return;
});

override(AvatarEditor.prototype, 'dropUpload', function() {
  return;
});

override(AvatarEditor.prototype, 'quickUpload', function() {
  return;
});

override(AvatarEditor.prototype, 'openPicker', function() {
  return;
});

override(AvatarEditor.prototype, 'upload', function() {
  return;
});

override(AvatarEditor.prototype, 'remove', function() {
  return;
});

override(AvatarEditor.prototype, 'success', function() {
  return;
});

override(AvatarEditor.prototype, 'failure', function() {
  return;
});
